import styled from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";

export const PageContainer = styled(PageWrapper)`
  &.entry-app-content {
    // padding-left: 60px;

    .content-holder {
      padding: 24px 20px;
    }

    .page-content {
      padding-top: 0;
      padding-right: 0;
      padding-left: 0;

      .table-content {
        border-radius: 15px 15px 0px 0px;
        thead th:first-child,
        thead th:last-child {
          border-radius: 0;
        }
      }

      .loader {
        display: flex;
        justify-content: center;
        margin-top: 50px;
      }
    }
  }

  @media (min-width: 1260px) {
    &.entry-app-content {
      padding-top: 0px;
      position: relative;
      padding-right: 0;
      // padding-left: 230px;
    }
  }
`;

export const Container = styled.div`
  margin-top: 200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    color: var(--color-purple);
    font-size: 3rem;
  }

  p {
    font-size: 1.5rem;
  }
`;
